<template>
  <v-card class="elevation-0">
    <ClassMarkDataTable :groups="groups" :singles="singles" :studentWithMark="studentWithMark" :headers="headers" />
  </v-card>
</template>
<script>
import ClassMarkDataTable from '@/modules/mark/ClassMarkDataTable.vue'
import { mapActions } from 'vuex'
export default {
  components: { ClassMarkDataTable },
  data() {
    return {
      groups: [],
      singles: [],
      studentWithMark: [],
      headers: [],
    }
  },
  methods: {
    ...mapActions({
      fetchReport: 'gradeClassMark/fetchReport',
    }),
    async refresh() {
      this.$loading.active = true
      try {
        const report = await this.fetchReport(this.$route.params.id)
        this.groups = report.groups
        this.singles = report.singles
        this.studentWithMark = report.studentWithMark
        this.headers = report.headers
      } catch (error) {
        console.error(error)
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },

  async created() {
    await this.refresh()
  },
}
</script>
